import React from 'react';

import { ListItem, ListItemButton, ListItemIcon, ListItemProps, Radio } from '@mui/material';

export type RadioListItemProps = Omit<ListItemProps, 'onChange'> & {
  checked?: boolean;
  hideRadio?: boolean;
  readonly?: boolean;
  onChange?: (value: string | number, checked: boolean) => void;
  children?: React.ReactNode;
  value: string | number;
};

const RadioListItem = ({ checked, hideRadio, readonly, children, onChange, value, ...props }: RadioListItemProps) => (
  <ListItem disablePadding {...props}>
    <ListItemButton onClick={() => !readonly && onChange?.(value, !checked)} dense>
      {!hideRadio && (
        <ListItemIcon>
          <Radio edge="start" checked={checked} tabIndex={-1} disableRipple />
        </ListItemIcon>
      )}
      {children}
    </ListItemButton>
  </ListItem>
);

export default RadioListItem;
